import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "contexts/TranslationContext";
import routes, { appRoute } from "shared/constants/routes";
import BackButton from "shared/components/BackButton/BackButton";
import OtherServiceCard from "components/Home/OtherServices/OtherServiceCard";
import ComingSoonModal from "components/Home/OtherServices/ComingSoonModal";
import {
  getServicesByCategory,
  OTHER_SERVICES_CATEGORY,
} from "components/Home/OtherServices/otherServicesData";

// "View All" page reached from the Home Other Services carousel. Two underline
// tabs (Other Services / Vehicle Services) filter the same catalog; each card
// opens the Coming Soon modal, matching the carousel's behavior.
const TABS = [
  { key: OTHER_SERVICES_CATEGORY.OTHER, labelKey: "OTHER_SERVICES.TITLE" },
  { key: OTHER_SERVICES_CATEGORY.VEHICLE, labelKey: "OTHER_SERVICES.VEHICLE_TITLE" },
];

const OtherServicesListing = () => {
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const [activeTab, setActiveTab] = useState(OTHER_SERVICES_CATEGORY.OTHER);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  const items = getServicesByCategory(activeTab);
  const titleHighlight = translate("OTHER_SERVICES.PAGE_TITLE_HIGHLIGHT");

  // Data-driven: services flagged comingSoon open the modal; the rest navigate
  // to their detail page.
  const handleServiceClick = (item) => {
    if (item?.comingSoon) {
      setComingSoonOpen(true);
    } else {
      navigate(appRoute(routes.OTHER_SERVICES + `/${item.id}`));
    }
  };

  return (
    <div className="rounded-xl mb-4 px-4 py-4">
      <div className="p-5">
        {/* Back button — same layout as the other listing pages */}
        <div className="flex items-center space-x-4">
          <div className="ml-3">
            <BackButton onClick={() => navigate(-1)} />
          </div>
        </div>

        {/* Centered header */}
        <div className="text-center mt-2">
          <h1 className="text-3xl md:text-4xl font-bold text-[#212044]">
            {translate("OTHER_SERVICES.PAGE_TITLE_LEAD")}
            {titleHighlight ? (
              <span className="text-primary"> {titleHighlight}</span>
            ) : null}
          </h1>
          <p className="text-[#8E9196] text-sm md:text-base mt-2">
            {translate("OTHER_SERVICES.SUBTITLE")}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center gap-8 mt-6">
          {TABS.map((tab) => {
            const isActive = tab.key === activeTab;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`pb-3 -mb-px text-sm md:text-base transition-colors border-b-2 ${
                  isActive
                    ? "text-primary border-primary font-semibold"
                    : "text-[#101010] border-transparent hover:text-primary"
                }`}
              >
                {translate(tab.labelKey)}
              </button>
            );
          })}
        </div>

        {/* Grid */}
        <div className="container mx-auto px-4 my-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
            {items.map((item) => (
              <OtherServiceCard
                key={item.id}
                item={item}
                onClick={handleServiceClick}
              />
            ))}
          </div>
        </div>
      </div>

      <ComingSoonModal open={comingSoonOpen} onClose={() => setComingSoonOpen(false)} />
    </div>
  );
};

export default OtherServicesListing;
